import { OpenAPI } from 'api/schema/core/OpenAPI'
import { request as __request } from 'api/schema/core/request'
import type { Point } from 'geojson'

type Paginated<T> = { results?: T[]; total?: number }

export interface ApiLotRow {
  id: number
  name: string
  lot_id: number
  type: number
  lot_model?: string | null
  robot_station_hardware_id?: string | null
}

export interface ApiMaintenancePointRow {
  id: number
  name: string
  type?: 'waste_water_drain' | 'debris_dump' | string
  facility_index?: number | null
  point?: Point | null
}

export interface ApiStationRow {
  id: number
  name: string
  station_id: string
  point?: Point | null
  reported_lot_ids?: number[]
  expects_telemetry?: boolean
}

const PAGE_SIZE = 500

async function fetchAllPages<T>(url: string, query: Record<string, unknown>): Promise<T[]> {
  const response = (await __request(OpenAPI, {
    method: 'GET',
    url,
    query: { ...query, page_size: PAGE_SIZE },
  })) as Paginated<T>
  return response.results ?? []
}

export async function fetchServiceCalibSourceRows(facilityId: number): Promise<{
  lots: ApiLotRow[]
  maintenancePoints: ApiMaintenancePointRow[]
  stations: ApiStationRow[]
}> {
  const [lots, maintenancePoints, stations] = await Promise.all([
    fetchAllPages<ApiLotRow>('/api/main/robot-lot/', { facility: facilityId }),
    fetchAllPages<ApiMaintenancePointRow>('/api/main/maintenance-point/', { facility: facilityId }),
    fetchAllPages<ApiStationRow>('/api/main/robot-station/', { facility: facilityId }),
  ])
  return { lots, maintenancePoints, stations }
}
